import React from "react";

/**
 * Orange count badge — matches Unread filter pill on Notifications page.
 */
export default function NotificationUnreadBadge({ count, className = "", title }) {
  const n = Number(count);
  if (!Number.isFinite(n) || n < 1) return null;
  const display = n > 99 ? "99+" : String(n);
  return (
    <span
      className={["inv-notifications-unread-badge", className].filter(Boolean).join(" ")}
      title={title || `${display} unread notification${n === 1 ? "" : "s"}`}
      aria-label={`${display} unread`}
    >
      {display}
    </span>
  );
}
